import { useMemo, useState } from 'react';
import { MenuItemResponse } from 'api/models';
import { useDebounce } from 'hooks/useDebounce';
import { menuItemName } from 'utils/menuItem';

export const useSearch = (foodList: MenuItemResponse[]) => {
  const [search, setSearch] = useState('');

  const { debouncedValue } = useDebounce(search);

  const findMatches = (title: string = '') => {
    const strLower = title.toLowerCase();
    return strLower.indexOf(debouncedValue.toLowerCase()) !== -1;
  };

  const filterMeals = (foodList: MenuItemResponse[]) => {
    return foodList.filter((value) => findMatches(menuItemName(value)));
  };

  const filteredMeals = useMemo(
    () => (debouncedValue ? filterMeals(foodList) : foodList),
    [debouncedValue, foodList],
  );

  return {
    search,
    setSearch,
    debouncedValue,
    filteredMeals,
  };
};
